/* --------------------------------------------------------------------------------------
   print.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class printService {
    /*@ngInject*/
  constructor (appSettings, deviceInfoService) {
    this.appSettings = appSettings
    this.deviceInfoService = deviceInfoService
  }
  submitPrint(reportGuid) {
    let blobUrl = this.appSettings.apiUrl + '/reports/' + reportGuid;
    return this.deviceInfoService.get()
      .then(result => this.submitPullPrintWrapper(result, blobUrl))
  }
  submitPullPrintWrapper(deviceInfo, blobUrl) {
    return new Promise(function(resolve, reject) {
      submitPullPrint(
        blobUrl,
        "report.pdf",
        "Connect for Remark Test Grading",
        (deviceInfo.paperPreferenceA4)? 'ISO_A4LEF' : 'NA_8.5x11LEF',
        jobId => resolve(jobId),
        err => reject(err)
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/print.service.js